import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, selectColumn } from "./ColumnHelpers";

export function column_FrequencyOfMicros(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn(context, "externalFrequencyOfMicros", "frequencyOfMicros", {
		isNumber: true,
		options: context.micros,
		size: 100,
		updateSubRows: context.dealBasedSubRowUpdate,
	});
}
